<template>
  <div class="payall">
    <iframe v-if="url!=''" :src="url"></iframe>
  </div>
</template>

<script>
  import axios from 'axios';
  export default {
    name: 'pay',
    data() {
       return {
         //http://10.0.48.157:8082/pay?paysty=xsolla&orderid=2010064268&gameid=20031&cg_request_id=0081fd68eca1a5fae94b316c956c7eef&product_id=400001&language=en&wecsocket_url=ws%3A%2F%2F127.0.0.1%3A10001&callback_type=app&pay_title=pc%20pay
        query:{
            // gameid:'20045',
            // orderid:'2010049129',
            // cg_request_id:'0081fd68eca1a5fae94b316c956c7eef',
            // language:'en',
            // product_id:'com.gamemaker5.idlemafia.d10',
            // pay_title:'pc微端支付',
            // wecsocket_url:''
        },
        parms:{
          // client_id:'test_ATYCG5EJPFEYPDRF6IQMLU2BLMNMNSPP',
          // paypal_client_id:'Aajv1SWxB_YSyoNzAwmBwVwXs2OIXlyIFpiC0CZNClF-se2biILKcNgPg9cxJthBvWhvf9C_pJSM_O1d',
          // is_allow3ds2:false
        },
        url:'',
        env:'prod',
        socket:'',
        connectis:false,
        mgsdict:{},
        web_interval:null,
        pcpaysty:'all',
        fpcs_url:process.env.FPCS_BASEURL+'/v1/transport/fpcs'
       }
    },
    mounted() {
      this.query = this.$route.query;
      console.log(this.query)
      if(window.location.hostname === 'vip-sandbox.centurygame.com' || window.location.hostname === 'localhost'){
        this.env = 'sandbox'
      }
      this.query.os = this.query.os?this.query.os:'pc';

      var vm = this;
      window.CGSDKJSONPResponse = function (data) {
        var obj = JSON.parse(data.config_set).payment;
        console.log('payment')
        console.log(obj)
        vm.parms = {
          adyen_client_key: obj.adyen ? obj.adyen.adyen_client_key :'',
          paypal_client_id:obj.paypal ? obj.paypal.paypal_client_id :'',
          is_allow3ds2:obj.adyen ? obj.adyen.enable_3ds2:'',
        };
        if(vm.query.os == 'pc'){
          vm.pcpaysty = obj.paysty;
        }else{
          vm.pcpaysty = obj.web.paysty;
        }
        //console.log(vm.parms);
        vm.setsrc()
      }

      if(this.query.idx && this.query.idx!=""){
        //console.log(this.query.idx)
          var fpcs_obj={
             service:'cdn_config',
             idx:this.query.idx,
             source:'web',
          }
          var fpcs_web_obj_formdata = new FormData();
          for(let k in fpcs_obj){
            fpcs_web_obj_formdata.append(k,fpcs_obj[k])
          }
          axios.post(this.fpcs_url, fpcs_web_obj_formdata , {
              withCredentials: false,
              headers: {
                'Accept': '*/*'
              }
          }).then(response => {
              if(response.data.status == 1){
                //执行操作
                var url = response.data.config_cdn_uri+'?v='+Date.now();
                this.creatScript(url).then(() => {});
              }
          }).catch(error => {
              console.log(error);
          });

      }else{
        //兼容老版本
          this.creatScript('https://fpcs-cdn.s3.amazonaws.com/record/' + this.env + '/' + this.query.gameid+'-funsdk-'+this.query.os+'-4.0-' + this.env + '.js?v='+ Date.now()).then(() => {

          })
      }



      //开启ifarme 通信
      this.iframe_plan_open();


      if(this.query.callback_type && this.query.callback_type =='app'){

      }else{
        //  console.log('this.query')
        // console.log(this.query)
        this.initWebsocketConn()
      }
    },
    methods:{
      initWebsocketConn(){
          var vm = this;
          if(this.socket!=''){
             this.socket.close();
          }
          this.socket = new WebSocket(this.query.wecsocket_url?this.query.wecsocket_url:this.query.websocket_url)
          this.socket.onopen = function(e) {
            vm.connectis = true;
          };
          this.socket.onmessage = function(e){
            var data = typeof e.data === 'object' ? e.data : JSON.parse(e.data);
            //console.log(data);
            if(data.data.action == 'web_pay_result_success'){
              vm.mgsdict[data.data.payload.provider_order_id] = true;
            }
          }
      },
      setsrc(){
        //&domain=web-sandbox.centurygame.com
        var url = "callback_type=4";

        var parmarr = ['gameid','orderid','cg_request_id','language','product_id','pay_title','is_allow3ds2'];

        parmarr.forEach(res=>{
          if(this.query[res] && this.query[res]!=''){
            if(res == 'pay_title'){
              url=url+"&"+res+'='+encodeURI(encodeURI(this.query[res]));
            }else{
              url=url+"&"+res+'='+this.query[res];
            }

          }else if(this.parms[res] && this.parms[res]!=''){
             url=url+"&"+res+'='+this.parms[res];
          }
        });
        var paysty = this.query.paysty;
        if(this.query.os=='pc'){
            paysty = this.pcpaysty;
        }
        if(paysty == 'adyen' || paysty == 'paypal' || paysty == 'xsolla'|| paysty == 'xsollaAll'){
           url=url+"&paysty="+paysty;
           url=url+"&client_id="+(paysty == 'adyen' ? this.parms.adyen_client_key : this.parms.paypal_client_id);
        }else{
          url=url+"&paysty=all";
          url=url+"&client_id="+this.parms.adyen_client_key+"&paypal_client_id="+this.parms.paypal_client_id;
        }

        url = url+'&paypal_orderid='+ this.query.orderid;
        //console.log(url)

        this.url = this.env == 'sandbox'? 'https://payment-sandbox.centurygame.com/cg_platform/web_sdk_view/?'+url+'#/' : 'https://payment-apa.centurygame.com/cg_platform/web_sdk_view/?'+url+'#/';
        //this.url = 'http://10.0.48.157:8081/pay?'+url+'#/';
        //console.log(this.url)
      },
      iframe_plan_open(){
          var vm = this
          window.onmessage = function(event){
            // console.log('event')
            // console.log(event.data.cg_payresult)
          	if(event.origin == 'https://payment-sandbox.centurygame.com' || event.origin == 'https://payment-apa.centurygame.com'){
          		var data = event.data;

          		if(data.cg_payresult){
                if(vm.query.callback_type && vm.query.callback_type =='app'){

                  console.log('=================')
                  console.log(vm.query)

                  var url = vm.query.scheme_header;
                  var result = data.cg_payresult;
                  for(let k in result){
                    url = url+ '&'+k+'='+result[k]
                  }
                  url = url.replace("&","?");
                  window.location.href = url;
                  //window.open(url);
                }else{
                  vm.sendclient(data.cg_payresult)
                }

          		}else if(data.moveconfig){
          			if(data.moveconfig.code == 1){
          				window.open(data.moveconfig.url)
          			}
          		}
          	}

          }
      },
      sendclient(obj){
        clearInterval(this.web_interval)
        var data ={
          "data":{
            "action":"web_pay_result",
            "payload":obj
          }
        }
        var vm = this;
        if(this.connectis == true){
          this.socket.send( JSON.stringify(data));
          var time = 1;
          this.web_interval = setInterval(function(){
             if((vm.mgsdict[obj.provider_order_id] && vm.mgsdict[obj.provider_order_id]==true) || time>3){
               clearInterval(vm.web_interval)
             }else{
               vm.socket.send( JSON.stringify(data));
               time++;
             }
          },2000)
        }
      },
      creatScript(src, id){
          return new Promise((r, j) => {
              var js = document.createElement('script');
              var fjs = document.getElementsByTagName('script')[0];
              if (id) {
                  if (document.getElementById(id)) {
                      r()
                      return
                  };
                  js.id = id;
              }
              js.src = src;
              fjs.parentNode.insertBefore(js, fjs);
              js.onload = function() {
                  r()
              }
              js.onerror = function() {
                  j()
              }
          })
      }

    }
  }
</script>

<style scoped="scoped">
  .payall{
    width: 100vw;
    height: 100vh;
    position: absolute;
    background: #FFFFFF;
    left: 0;
    top: 0;
    z-index: 1000;
    background-image: url('https://gpage.centurygame.com/web-pay-sandbox/static/images/load.gif');
    background-repeat: no-repeat;
    background-size: 40px 40px;
    background-position:center 140px;
    overflow: hidden;
  }
  .payall iframe{
    width: 100%;
    border: none;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/pay.vue